import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-479976c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner relative" }
const _hoisted_2 = ["src"]




export default /*#__PURE__*/_defineComponent({
  __name: 'BannerView',
  props: {
    imgBg: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", { src: __props.imgBg }, null, 8, _hoisted_2),
    _renderSlot(_ctx.$slots, "extraOpt")
  ]))
}
}

})